var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.795 40H2.205a2.208 2.208 0 01-2.2-2.205V2.205A2.207 2.207 0 012.205 0h35.591a2.207 2.207 0 012.2 2.205v35.59A2.208 2.208 0 0137.795 40zm-11.8-19.529c1.818 0 2.664 1.169 2.664 3.68v8.715h5.61v-9.338a8.873 8.873 0 00-1.756-5.772 5.7 5.7 0 00-4.524-2.021 5.948 5.948 0 00-3.366.929 6.161 6.161 0 00-1.691 1.76v-2.307h-5.783c.073 1.485 0 16.123 0 16.745h5.788v-9.1a3.448 3.448 0 01.185-1.319 3.38 3.38 0 011.01-1.354 2.949 2.949 0 011.865-.618zM7.423 15.997v16.869h5.421V15.997zm2.432-7.438a2.838 2.838 0 00-.062 5.667h.031a2.613 2.613 0 001.985-.827 2.942 2.942 0 00.731-2.006 2.652 2.652 0 00-2.684-2.834z",
    fill: "#7e91b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.13f0cf896384351ea3278cadf35f0640.svg";
export { ForwardRef as ReactComponent };